/**
 * The canonical public path for a club page: scorepal.co/club/{slug}, for EVERY club — venue,
 * team and community alike. Venues used to keep the root vanity path (scorepal.co/{slug}); that
 * was retired so every club lives in one place, clear of the 70+ static marketing routes at the
 * root, where a static route always wins the match and a colliding club page goes silently dark.
 * Root URLs shared before still work: the root catch-all 301s them here.
 *
 * `type` is kept in the signature so callers need not change; it no longer decides anything.
 *
 * Keep this the only place that builds a club URL — the previous hand-rolled `/${slug}` call
 * sites are exactly how the rule would drift back out of sync. The one backend counterpart is
 * OrganizerWelcomeMail::clubPagePath, which must follow the same rule.
 */
export function clubPagePath(slug: string, _type?: number | string | null): string {
    return `/club/${slug}/`;
}
